import React, {
    useEffect,
    useRef,
    useState
} from "react";
import { 
    Form,
    useLocation,
    useNavigate
} from 'react-router-dom';
import { LoadScript, Autocomplete } from '@react-google-maps/api';
import Ajax from "../inc/js/Ajax";
import {
    ArrowUpRight8White,
    ClipboardList_6_Blue,
    Cog6Blue,
    Form_6_Blue,
    Link_6_Blue,
    QRCode_6_Blue,
    ShareIcon_6_Blue,
    Trash_8_Red
} from "../inc/images/svgs";
import {
    downloadQRCode,
    getCurrentDate,
    HelmetWrapper,
    textToClipboard
} from "../inc/js/Helper"
import swal from "sweetalert2";
import {
    Button,
    Divider,
    Dropdown,
    DropdownTrigger,
    DropdownMenu,
    DropdownItem,
    Input,
    Modal,
    ModalContent,
    ModalHeader,
    ModalBody,
    Popover,
    PopoverTrigger,
    PopoverContent,
    Spacer,
    Tab,
    Tabs,
    Table,
    TableHeader,
    TableColumn,
    TableBody,
    TableRow,
    TableCell
} from "@nextui-org/react";

const libraries = ['places'];

export default function Event({clientInformation}) {
    const location = useLocation();
    const navigate = useNavigate();
    const validateEmail = (email) => email.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,16}$/i);
    const validatePhoneNumber = (number) => number.replace(/-/g, '').length === 10;
    const eventId = location.state?.eventId || localStorage.getItem('eventId');
    const host = window.location.hostname;
    const [classValue, setClassValue] = useState();
    const [eventDetails, setEventDetails] = useState([]);
    const [eventDetailsUpdate, setEventDetailsUpdate] = useState(false);
    const [classList, setClassList] = useState();
    const [isMobile, setIsMobile] = useState();
    const [judgeForm, setJudgeForm] = useState();
    const [registrationForm, setRegistrationForm] = useState(); 
    const [advancedForm, setAdvancedForm] = useState();   
    const [validEmail, setValidEmail] = useState();
    const [selectedRegistrationColumns, setSelectedRegistrationColumns] = useState(new Set());
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    const [registrationModalOpen, setRegistrationModalOpen] = useState(false);
    const [registrationModalInput, setRegistrationModalInput] = useState(false);
    const [registrationModalData, setRegistrationModalData] = useState({});
    const [registrationModalInputValues, setRegistrationModalInputValues] = useState({});
    
    const [participantModalInput, setParticipantModalInput] = useState(false);
    const [participantModalOpen, setParticipantModalOpen] = useState(false);
    const [participantModalData, setParticipantModalData] = useState({});
    const [participantModalInputValues, setParticipantModalInputValues] = useState({
        name: '',
        phoneNumber: '',
        email: '',
        admin: ''
    });

    const autocompleteRef = useRef(null);
    const locationInputRef = useRef(null);

    const eventData = eventDetails.eventData?.[0] || {};
    const eventName = eventData.eventName || null;
    const eventStatus = eventData.status || null;
    const isCompleted = eventStatus === "completed";

    useEffect(() => {
        if (clientInformation.userInformation.loggedIn === false) {
            document.location.href = "/Login";
        }
    }, [clientInformation]);

    useEffect(() => {
        localStorage.setItem('eventId', eventId);

        Ajax.request({
            url:'/JudgeAutos/readEventDetails?eventId=' + eventId,
            success:function(reply) {
                if(reply.data) {
                    setEventDetails(reply.data);
                    setClassValue(reply.data.classes.length + 1);
                    setJudgeForm(reply.data.eventData[0].judgeFormId);
                    setRegistrationForm(reply.data.eventData[0].registrationFormId);
                    setAdvancedForm(reply.data.eventData[0].advancedFormId);
                    setClassList(reply?.data?.eventData?.[0]?.classListName ?? 'noClassList');
                    setSelectedRegistrationColumns(
                        window.innerWidth < 640
                            ? new Set(["Number", "Name", "Phone Number", "score"])
                            : new Set(reply.data.formSubmissions?.[0] ? Object.keys(reply.data.formSubmissions[0]) : [])
                    );
                }
            },
            failure:function(reply) {
                swal.fire({
                    title: "Whoopsie daisy",
                    html: "Something is wrong here.  Please <a href='/ContactUs' style='text-decoration: underline; color: blue;'>Contact Us</a> for help",
                    icon: "error",
                    didClose: () => {
                        document.location.href = "/ContactUs"
                    }
                })
            }
        });
    }, []);

    const onPlaceChanged = () => {
        if (autocompleteRef.current !== null) {
            const place = autocompleteRef.current.getPlace();
            
            if (place && place.formatted_address) {
                handleEventDetailsChange('eventLocation', place.formatted_address);
            } else if (place && place.name) {
                handleEventDetailsChange('eventLocation', place.name);
            }
        }
    };

    useEffect(() => {
        const handleResize = () => {
            const newWidth = window.innerWidth;
            const isNowMobile = newWidth < 640;
    
            if (Math.abs(newWidth - screenWidth) > 100) {
                setScreenWidth(newWidth);
                setIsMobile(isNowMobile);
    
                if (eventDetails?.formSubmissions?.length > 0) {
                    setSelectedRegistrationColumns(
                        isNowMobile
                            ? new Set(["Number", "Name", "Phone Number", "score"])
                            : new Set(Object.keys(eventDetails.formSubmissions[0]))
                    );
                }
            }
        };
    
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [screenWidth, eventDetails]);
    
    useEffect(() => {
        if (participantModalData.participantData) {
            setParticipantModalInputValues({
                name: participantModalData.participantData.name,
                phoneNumber: participantModalData.participantData.phoneNumber,
                email: participantModalData.participantData.email,
                admin: participantModalData.participantData.admin
            });
        }
    }, [participantModalData]);

    useEffect(() => {
        setValidEmail(validateEmail(participantModalInputValues.email) || participantModalInputValues.email === '' ? true : false);
    }, [participantModalInputValues.email]);
    
    const handleEventDetailsChange = (field, value) => {
        setEventDetails(prev => ({
            ...prev,
            eventData: prev.eventData.map(data => ({
                ...data,
                [field]: value
            }))
        }));
        setEventDetailsUpdate(true);
    };

    const addParticipant = (role, input) => {
        const participantData = {
            eventId: eventId,
            participantRole: role,
            participantName: input.name,
            participantPhoneNumber: input.phoneNumber,
            participantEmail: input.email,
            participantAdmin: (input.admin === 0 || input.admin === '') ? 0 : input.admin
        };

        if (eventDetails[`${role}s`].length < eventDetails.eventData[0].registrarLimit) {
            if (validateParticipantData(participantData)) {
                Ajax.request({
                    url:"/JudgeAutos/addParticipant",
                    jsonData: participantData,
                    success:function(reply) {
                        swal.fire({
                            title:`Added ${role}`,
                            text:`${participantData.participantName} has been added!`,
                            icon:"success",
                            timer: 1500,
                            didClose: () => {
                                window.location.reload();
                            }
                        })
                    }
                });
            }
        } else {
            swal.fire({
                title: "Oops!",
                text: `You have reached your ${role} limit!`,
                icon: "error"
            });
        }
    }

    const deleteParticipant = (participantData) => {
        Ajax.request({
            url:"/JudgeAutos/deleteParticipant",
            jsonData: participantData,
            success:function(reply) {
                swal.fire({
                    title:`Deleted ${participantData.participantRole}!`,
                    text: reply.data,
                    icon:"success",
                    timer: 3000,
                    didClose: () => {
                        window.location.reload();
                    }
                })
            }
        });
    }

    const deleteRegistration = (registrationData) => {
        const registrationId = registrationData.registrationId;

        Ajax.request({
            url:"/JudgeAutos/deleteRegistration",
            jsonData: {
                registrationId: registrationId
            },
            success:function(reply) {
                swal.fire({
                    title: "Success!",
                    text: `${reply.data} ${registrationData.Number}`,
                    icon: "success",
                    timer: 3000,
                    didClose: () => {
                        window.location.reload();
                    }
                });
            }
        });
    }

    const handleSelectedRegistrationColumns = (keys) => {
        setSelectedRegistrationColumns(new Set(keys));
    };

    const openRegistrationModal = (registrationData) => {
        if (!isCompleted) {
            setRegistrationModalData(Object.fromEntries(Object.entries(registrationData)));
            setRegistrationModalInputValues(Object.fromEntries(Object.entries(registrationData)));
            setRegistrationModalOpen(true);
        }
    }

    const openParticipantModal = (participantRole, participantData) => {
        if (!isCompleted) {
            setParticipantModalData({
                participantRole: participantRole,
                participantData: participantData
            });
            setParticipantModalOpen(true);
        }
    }

    const sendInvite = (id, contactName, contactInformation, qrCode, userRole, contactMethod) => {
        const contactForm = {
            id: id,
            name: contactName,
            contactInformation: contactInformation,
            qrCode: qrCode,
            eventName: eventName,
            userRole: userRole,
            contactMethod: contactMethod,
            ipAddress: clientInformation.ipAddress || 'UNKNOWN'
        }
        
        Ajax.request({
            url:"/JudgeAutos/sendInvite",
            jsonData: contactForm,
            success:function() {
                swal.fire({
                    title: "Sent!",
                    text: `An invite has been sent to ${contactForm.name}`,
                    icon: "success"
                });
            }
        });
    }

    const updateEvent = () => {
        const currentDate = getCurrentDate();
        const data = eventDetails.eventData[0];
        
        const updateForm = {
            eventId: data.eventId,
            eventName: data.eventName,
            eventLocation: data.eventLocation,
            eventDate: data.eventDate,
            rainoutDate: data.rainoutDate,
            registrationForm: registrationForm,
            registrationFormId: eventDetails.registrationForms.find(form => form.registrationFormId == registrationForm).registrationFormId,
            judgeForm: judgeForm,
            judgeFormId: eventDetails.judgeForms.find(form => form.judgeFormId == judgeForm).judgeFormId,
            advancedForm: advancedForm,
            advancedFormId: eventDetails.advancedForms.find(form => form.advancedFormId == advancedForm).advancedFormId,
            classListId: eventDetails?.classLists?.find(id => id.classListName === classList)?.classListId ?? null
        };
        
        if (updateForm.eventDate === currentDate) {
            updateForm.status = "active"
        } else if (updateForm.eventDate > currentDate) {
            updateForm.status = "upcoming"
        } else {
            swal.fire({
                title: "Invalid event date",
                text: "The event date cannot be in the past",
                icon: "error",
                timer: 1500
            })
            return;
        }

        if (updateForm.rainoutDate === "") {
            updateForm.rainoutDate = null;
        } else if (updateForm.rainoutDate < currentDate) {
            swal.fire({
                title: "Invalid rainout date",
                text: "The rainout date cannot be in the past",
                icon: "error",
                timer: 1500
            })
            return;
        }

        Ajax.request({
            url:"/JudgeAutos/updateEvent",
            jsonData:updateForm,
            success:function(reply) {
                swal.fire({
                    title: "Success!",
                    text: "Event Updated",
                    icon: "success",
                    timer: 1500,
                    didClose: () => {
                        window.location.reload();
                    }
                });
            }
        });
    }

    const updateParticipant = (participantRole, input) => {
        const roleId = participantRole === "judge" ? participantModalData.participantData.judgeId : participantModalData.participantData.registrarId;
        
        const participantData = {
            participantRole: participantRole,
            participantId: roleId,
            participantName: input.name,
            participantPhoneNumber: input.phoneNumber.replace(/[^0-9]/g, ''),
            participantEmail: input.email,
            participantAdmin: input.admin
        }

        if (validateParticipantData(participantData)) {
            Ajax.request({
                url:"/JudgeAutos/updateParticipant",
                jsonData: participantData,
                success:function(reply) {
                    swal.fire({
                        title:`${participantRole.charAt(0).toUpperCase() + participantRole.slice(1)} updated!`,
                        text: reply.data,
                        icon:"success",
                        timer: 3000,
                        didClose: () => {
                            window.location.reload();
                        }
                    })
                }
            });
        }
    }

    const updateRegistration = (registrationData) => {
        delete registrationData.score;
        const registrationId = registrationData.registrationId;
        delete registrationData.registrationId;

        Ajax.request({
            url:"/JudgeAutos/updateRegistration",
            jsonData: {
                eventId: eventId,
                registrationId: registrationId,
                registrationData: [registrationData]
            },
            success:function(reply) {
                swal.fire({
                    title: "Success!",
                    text: `Registration ${reply.data} updated`,
                    icon: "success",
                    timer: 3000,
                    didClose: () => {
                        window.location.reload();
                    }
                });
            }
        });
    }

    const validateParticipantData = (participantData) => {
        let validParticipantData = true;

        if (!participantData.participantName || !(participantData.participantPhoneNumber || participantData.participantEmail)) {
            swal.fire({
                title: "Missing fields!",
                html: `Please enter a <strong>name</strong> and a <strong>phone number or email</strong>.`,
                icon: "error",
                timer: 3000
            });
            validParticipantData = false;
        }
            
        if (participantData.participantPhoneNumber && !validatePhoneNumber(participantData.participantPhoneNumber) && validParticipantData) {
            swal.fire({
                title: "Invalid Phone Number",
                html: `Please enter a 10 digit phone number`,
                icon: "error",
                timer: 3000
            });
            validParticipantData = false;
        }

        if (participantData.participantEmail && !validateEmail(participantData.participantEmail) && validParticipantData) {
            swal.fire({
                title: "Invalid Email Address",
                html: `Please enter a valid email address`,
                icon: "error",
                timer: 3000
            });

            validParticipantData = false;
        }

        return validParticipantData;
    }

    const viewResults = () => {
        navigate('/Results', {
            state: {
                eventId,
                eventName,
                eventStatus
            } 
        });
    };

    // WORK AROUND FOR NEXTUI ISSUE 1968
    const dummyKeyboardDelegate = Object.fromEntries(
        [
          "getKeyBelow",
          "getKeyAbove",
          "getKeyLeftOf",
          "getKeyRightOf",
          "getKeyPageBelow",
          "getKeyPageAbove",
          "getFirstKey",
          "getLastKey",
        ].map((name) => [name, () => null]),
    );
    
    const hasCustomForms = eventData.forms === "custom";
    const classLimit = eventData.classLimit ?? 0;

    return(
        <LoadScript
            googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}
            libraries={libraries}
        >
            <>
                <HelmetWrapper
                    title="JudgeAutos - Event"
                    description="Manage your selected car, truck, or bike show in JudgeAutos, including participants, judging, and event details."
                    url="Event"
                />
                            
                <div className="flex flex-col text-center mx-auto items-center w-fit">
                    <h1 className="text-5xl">{eventName}</h1>
                    <Spacer y={1} />
                    <p>
                        ({eventStatus})
                    </p>
                    {eventStatus === "completed" || eventStatus === "active" ? (
                        <div>
                            <Spacer y={5} />
                            <div >
                                <Divider orientation="vertical"/>
                                <Divider orientation="vertical"/>
                            </div>
                            <Spacer y={4} />
                        </div>
                    ): (
                        <Spacer y={9} />
                    )}
                    {eventDetails.eventData && (
                        <Tabs
                            size={isMobile ? "sm" : "md"}
                            classNames={{
                                tabList: "gap-0 sm:gap-2"
                            }}
                        >
                            {eventDetails.formData?.length > 0 && (
                                <Tab key="registrations" title="Registrations" aria-label="Registrations tab">
                                    {eventDetails.formSubmissions?.length > 0 ? (
                                        <div>
                                            <div className="flex mx-auto justify-center -my-2 sm:my-auto items-center space-x-4">
                                                <Dropdown closeOnSelect={false} shouldBlockScroll={false}>
                                                    <DropdownTrigger>
                                                        <Button
                                                            variant="bordered"
                                                            color="default"
                                                        >
                                                            Columns
                                                        </Button>
                                                    </DropdownTrigger>
                                                        <DropdownMenu
                                                            disallowEmptySelection
                                                            aria-label="Registration Table Columns Dropdown"
                                                            selectionMode="multiple"
                                                            selectedKeys={Array.from(selectedRegistrationColumns)}
                                                            onSelectionChange={handleSelectedRegistrationColumns}
                                                        >
                                                            {Object.keys(eventDetails.formSubmissions[0]).filter(
                                                                (key) => key !== "registrationId"
                                                            ).map((key, index) => (
                                                                <DropdownItem key={`${key}`}>
                                                                    {key.split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")}
                                                                </DropdownItem>
                                                            ))}
                                                            <DropdownItem 
                                                                key="resetColumnSelectionsButton"
                                                                onPress={(e) => {
                                                                    setSelectedRegistrationColumns(new Set(["Number", "Name", "Phone Number", "score"]))
                                                                }}
                                                            >
                                                                <div className="flex mx-auto justify-center">
                                                                    <Button
                                                                        variant="solid"
                                                                        size={isMobile ? "sm" : "md"}
                                                                        color="primary"
                                                                        onPress={() =>
                                                                            setSelectedRegistrationColumns(new Set(["Number", "Name", "Phone Number", "score"]))
                                                                        }
                                                                    >
                                                                        Reset
                                                                    </Button>
                                                                </div>
                                                            </DropdownItem>
                                                        </DropdownMenu>
                                                </Dropdown>
                                                <Button 
                                                    variant="bordered"
                                                    color="default"
                                                    onPress={viewResults}
                                                >
                                                    Results
                                                </Button>
                                            </div>
                                            <Spacer y={4} />
                                            <Table
                                                isStriped
                                                aria-label="Event registrations"
                                                layout="fixed"
                                            >
                                                <TableHeader>
                                                    {Object.keys(eventDetails.formSubmissions[0]).filter(
                                                        (key) => key !== "registrationId"
                                                    ).map((key, index) => (
                                                        <TableColumn
                                                            key={key}
                                                            align="center"
                                                            className={
                                                                selectedRegistrationColumns.has(key)
                                                                    ? "table-cell text-center"
                                                                    : "hidden"
                                                            }
                                                        >
                                                            {key.split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")}
                                                        </TableColumn>
                                                    ))}
                                                </TableHeader>
                                                <TableBody>
                                                    {eventDetails?.formSubmissions?.length > 0 && 
                                                        eventDetails?.formSubmissions?.map((data, index) => (
                                                            <TableRow
                                                                key={index}
                                                                style={{cursor: "pointer"}}
                                                                onClick={() => openRegistrationModal(data)}
                                                            >
                                                                {Object.keys(data).filter(
                                                                    (key) => key !== "registrationId"
                                                                ).map((key, innerIndex) => (
                                                                    <TableCell
                                                                        key={innerIndex}
                                                                        className={
                                                                            selectedRegistrationColumns.has(key)
                                                                                ? "table-cell"
                                                                                : "hidden"
                                                                        }
                                                                    >
                                                                        {data[key]}
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                        ))
                                                    }
                                                </TableBody>
                                            </Table>
                                        </div>
                                    ) : (
                                        <div>
                                            <Spacer y={5} />
                                            <p>
                                                No registrations just yet!
                                            </p>
                                            <Spacer y={5} />
                                            <Button
                                                variant="solid"
                                                color="primary"
                                                onPress={() => {
                                                    window.location.reload();
                                                }}
                                            >
                                                Refresh
                                            </Button>
                                        </div>
                                    )}
                                </Tab>
                            )}
                            {classList !== "noClassList"  && (
                                <Tab key="classes" title="Classes" aria-label="Classes tab" >
                                        <Table isStriped aria-label="Clases" keyboardDelegate={dummyKeyboardDelegate}>
                                            <TableHeader>
                                                <TableColumn>Class Number</TableColumn>
                                                <TableColumn>Class Name</TableColumn>
                                                <TableColumn>Registrations</TableColumn>
                                            </TableHeader>
                                            <TableBody>
                                                {eventDetails.classes.map((data, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell>{data.classNumber}</TableCell>
                                                        <TableCell>{data.className}</TableCell>
                                                        <TableCell>{data.classCount}</TableCell>
                                                    </TableRow>
                                                ))};
                                            </TableBody>
                                        </Table>
                                </Tab>
                            )}
                            <Tab key="registrars" title="Registrars" aria-label="Registrars tab">
                                <Table isStriped aria-label="Registrars" keyboardDelegate={dummyKeyboardDelegate}>
                                    <TableHeader>
                                        <TableColumn>Name</TableColumn>
                                        <TableColumn className="hidden sm:table-cell">Number</TableColumn>
                                        <TableColumn className="hidden sm:table-cell">Email</TableColumn>
                                        <TableColumn>Cars Registered</TableColumn>
                                    </TableHeader>
                                    <TableBody>
                                        {eventDetails.registrars.map((data, index) => (
                                            <TableRow
                                                key={index}
                                                style={!isCompleted ? { cursor: "pointer" } : { cursor: "default" }}
                                                onClick={() => openParticipantModal("Registrar", data)}
                                            >
                                                <TableCell>{data.name}</TableCell>
                                                <TableCell className="hidden sm:table-cell">{data.phoneNumber}</TableCell>
                                                <TableCell className="hidden sm:table-cell">{data.email}</TableCell>
                                                <TableCell>{data.carsRegistered}</TableCell>
                                            </TableRow>
                                        ))};
                                    </TableBody>
                                </Table>
                                <div className="p-5">
                                    <Button
                                        variant="solid"
                                        color="primary"
                                        size="sm"
                                        isDisabled={
                                            isCompleted ||
                                            eventDetails.registrars.length >= eventDetails.eventData[0].registrarLimit
                                        }
                                        onPress={() => openParticipantModal("Registrar", participantModalInputValues)}
                                    >
                                        Add Registrar
                                    </Button>
                                </div>
                            </Tab>
                            <Tab key="judges" title="Judges" aria-label="Judges tab">
                                <Table isStriped aria-label="Judges" keyboardDelegate={dummyKeyboardDelegate}>
                                    <TableHeader>
                                        <TableColumn>Name</TableColumn>
                                        <TableColumn className="hidden sm:table-cell">Number</TableColumn>
                                        <TableColumn className="hidden sm:table-cell">Email</TableColumn>
                                        <TableColumn>Cars Judged</TableColumn>
                                    </TableHeader>
                                    <TableBody>
                                        {eventDetails.judges.map((data, index) => (
                                            <TableRow
                                                key={index}
                                                style={!isCompleted ? { cursor: "pointer" } : { cursor: "default"}}
                                                onClick={() => openParticipantModal("Judge", data)}
                                            >
                                                <TableCell>{data.name}</TableCell>
                                                <TableCell className="hidden sm:table-cell">{data.phoneNumber}</TableCell>
                                                <TableCell className="hidden sm:table-cell">{data.email}</TableCell>
                                                <TableCell>{data.carsJudged}</TableCell>
                                            </TableRow>
                                        ))};
                                    </TableBody>
                                </Table>
                                <div className="p-5">
                                    <Button
                                        variant="solid"
                                        color="primary"
                                        size="sm"
                                        isDisabled={
                                            isCompleted ||
                                            eventDetails.judges.length >= eventDetails.eventData[0].judgeLimit
                                        }
                                        onPress={() => openParticipantModal("Judge", participantModalInputValues)}
                                    >
                                        Add Judge
                                    </Button>
                                </div>
                            </Tab>
                            <Tab key="eventTab" title="Event" aria-label="Event Tab">
                                {eventDetails.eventData?.length > 0 && eventDetails.eventData.map((data, index) => (
                                    <Form key={index}>
                                        <Popover placement="bottom" offset={10} showArrow>
                                            <PopoverTrigger>
                                                <Input
                                                    isReadOnly
                                                    id="eventStatus"
                                                    type="text"
                                                    label="Status"
                                                    variant="flat"
                                                    value={`${data.status.charAt(0).toUpperCase() + data.status.slice(1)} Event`}
                                                    classNames={{
                                                        input: "text-left text-[16px]",
                                                    }}
                                                />
                                            </PopoverTrigger>
                                            <PopoverContent>
                                            <div className="px-1 py-2">
                                                <div className="text-small font-bold">NOTICE</div>
                                                <div className="text-tiny">To change the status, update the Event Date</div>
                                            </div>
                                            </PopoverContent>
                                        </Popover>
                                        <Spacer y={1} />
                                        <Input
                                            isReadOnly
                                            id="productName"
                                            type="text"
                                            label="Product"
                                            variant="flat"
                                            classNames={{input: "text-[16px]"}}
                                            value={data.productName}
                                        />
                                        <Spacer y={1} />
                                        <Input
                                            readOnly={isCompleted}
                                            id="eventName"
                                            type="text"
                                            label="Event Name"
                                            variant={isCompleted ? "flat" : "bordered"}
                                            classNames={{input: "text-[16px]"}}
                                            value={data.eventName}
                                            onValueChange={(value) => handleEventDetailsChange("eventName", value)}
                                        />
                                        <Spacer y={1} />
                                        <Input
                                            readOnly={isCompleted}
                                            id="eventDate"
                                            type="date"
                                            label="Event Date"
                                            variant={isCompleted ? "flat" : "bordered"}
                                            classNames={{input: "text-[16px]"}}
                                            value={data.eventDate.split(" ")[0]}
                                            onValueChange={(value) => handleEventDetailsChange("eventDate", value)}
                                        />
                                        <Spacer y={1} />
                                        <Input
                                            readOnly={isCompleted}
                                            id="rainoutDate"
                                            type="date"
                                            label="Rainout Date"
                                            variant={isCompleted ? "flat" : "bordered"}
                                            classNames={{input: "text-[16px]"}}
                                            value={data.rainoutDate ? data.rainoutDate.split(" ")[0] : ""}
                                            onValueChange={(value) => handleEventDetailsChange("rainoutDate", value)}
                                        />
                                        <Spacer y={1} />
                                        <Autocomplete
                                            onLoad={(autocomplete) => {
                                                autocompleteRef.current = autocomplete;
                                            }}
                                            onPlaceChanged={onPlaceChanged}
                                            options={{
                                                types: ['establishment', 'geocode'],
                                                fields: ['formatted_address', 'name', 'place_id']
                                            }}
                                        >
                                            <Input
                                                ref={locationInputRef}
                                                readOnly={isCompleted}
                                                id="eventLocation"
                                                type="text"
                                                label="Event Location"
                                                placeholder="Search for a location..."
                                                variant={isCompleted ? "flat" : "bordered"}
                                                classNames={{input: "text-[16px]"}}
                                                value={data.eventLocation}
                                                onChange={(e) => handleEventDetailsChange("eventLocation", e.target.value)}
                                            />
                                        </Autocomplete>
                                        <Spacer y={1} />
                                        <div className="grid grid-cols-2 gap-2 place-content-center">
                                            <Dropdown isDisabled={isCompleted || !hasCustomForms}>
                                                <DropdownTrigger>
                                                    <Button
                                                        variant={isCompleted || !hasCustomForms ? "solid" : "bordered"}
                                                        endContent={<Form_6_Blue />}
                                                    >
                                                        Registration Form
                                                    </Button>
                                                </DropdownTrigger>
                                                <DropdownMenu
                                                    disabled={!hasCustomForms || isCompleted}
                                                    disallowEmptySelection
                                                    aria-label="Registration Form Dropdown Menu"
                                                    selectionMode="single"
                                                    selectedKeys={new Set([registrationForm])}
                                                    onSelectionChange={
                                                        hasCustomForms && !isCompleted && (
                                                            (selected) => {
                                                                const selectedKey = Array.from(selected)[0];
                                                                if (selectedKey == null) return;
                                                                setRegistrationForm(selectedKey);
                                                                setEventDetailsUpdate(true)
                                                            }
                                                        )
                                                    }
                                                >
                                                    {eventDetails.registrationForms.map((data, index) => (
                                                        <DropdownItem key={data.registrationFormId}>{data.formName}</DropdownItem>
                                                    ))}
                                                    <DropdownItem href="/Forms?tab=Registration"><p className="text-blue-500 font-bold">+ New Form</p></DropdownItem>
                                                </DropdownMenu>
                                            </Dropdown>
                                            <Dropdown isDisabled={isCompleted || !hasCustomForms}>
                                                <DropdownTrigger>
                                                    <Button
                                                        variant={isCompleted || !hasCustomForms ? "solid" : "bordered"}
                                                        endContent={<Form_6_Blue />}
                                                    >
                                                        Judge Form
                                                    </Button>
                                                </DropdownTrigger>
                                                <DropdownMenu
                                                    disabled={!hasCustomForms || isCompleted}
                                                    disallowEmptySelection
                                                    aria-label="Judge Form Dropdown Menu"
                                                    selectionMode="single"
                                                    selectedKeys={new Set([judgeForm])}
                                                    onSelectionChange={
                                                        hasCustomForms && !isCompleted && (
                                                            (selected) => {
                                                                const selectedKey = Array.from(selected)[0];
                                                                if (selectedKey == null) return;
                                                                setJudgeForm(selectedKey);
                                                                setEventDetailsUpdate(true)
                                                            }
                                                        )
                                                    }
                                                >
                                                    {eventDetails.judgeForms.map((data, index) => (
                                                        <DropdownItem key={data.judgeFormId}>{data.formName}</DropdownItem>
                                                    ))}
                                                    <DropdownItem href="/Forms?tab=Judging"><p className="text-blue-500 font-bold">+ New Form</p></DropdownItem>
                                                </DropdownMenu>
                                            </Dropdown>
                                            <Dropdown isDisabled={isCompleted || classLimit === 0}>
                                                <DropdownTrigger>
                                                    <Button
                                                        variant={isCompleted || classLimit === 0 ? "solid" : "bordered"}
                                                        endContent={<ClipboardList_6_Blue />}
                                                    >
                                                        Class List
                                                    </Button>
                                                </DropdownTrigger>
                                                <DropdownMenu
                                                    disabled={isCompleted}
                                                    disallowEmptySelection
                                                    aria-label="Class List Dropdown Menu"
                                                    selectionMode="single"
                                                    selectedKeys={new Set([classList])}
                                                    onSelectionChange={
                                                        classLimit > 0 && (
                                                            (selected) => {
                                                                const selectedKey = Array.from(selected)[0];
                                                                if (selectedKey == null) return;
                                                                setClassList(selectedKey);
                                                                setEventDetailsUpdate(true)
                                                            }
                                                        )
                                                    }
                                                >
                                                    <DropdownItem key="noClassList">None</DropdownItem>
                                                    {eventDetails.classLists.map((data, index) => (
                                                        <DropdownItem key={data.classListName}>{data.classListName}</DropdownItem>
                                                    ))}
                                                    <DropdownItem href="/Forms?tab=Classes"><p className="text-blue-500 font-bold">+ New List</p></DropdownItem>
                                                </DropdownMenu>
                                            </Dropdown>
                                            <Dropdown isDisabled={isCompleted}>
                                                <DropdownTrigger>
                                                    <Button
                                                        variant={isCompleted ? "solid" : "bordered"}
                                                        id="Options"
                                                        endContent={<Cog6Blue />}
                                                    >
                                                        Options
                                                    </Button>
                                                </DropdownTrigger>
                                                <DropdownMenu
                                                    disabled={isCompleted}
                                                    disallowEmptySelection
                                                    aria-label="Options Dropdown Menu"
                                                    selectionMode="single"
                                                    selectedKeys={new Set([advancedForm])}
                                                    onSelectionChange={
                                                        !isCompleted && (
                                                            (selected) => {
                                                                const selectedKey = Array.from(selected)[0];
                                                                if (selectedKey == null) return;
                                                                setAdvancedForm(selectedKey);
                                                                setEventDetailsUpdate(true);
                                                            }
                                                        )
                                                    }
                                                >
                                                    {eventDetails.advancedForms.map((data, index) => (
                                                        <DropdownItem key={data.advancedFormId}>{data.formName}</DropdownItem>
                                                    ))}
                                                    <DropdownItem href="/Forms?tab=Options"><p className="text-blue-500 font-bold">+ New</p></DropdownItem>
                                                </DropdownMenu>
                                            </Dropdown>
                                            <Popover
                                                onOpenChange={(open) => {
                                                    if (open) {
                                                        textToClipboard(`${host}/EventView?code=${data.qrCode}`);
                                                    }
                                                }}
                                            >
                                                <PopoverTrigger>
                                                    <Button
                                                        variant="bordered"
                                                        id="eventLink"
                                                        endContent={<Link_6_Blue />}
                                                    >
                                                        Event Link
                                                    </Button>
                                                </PopoverTrigger>
                                                <PopoverContent>
                                                    Link copied!
                                                </PopoverContent>
                                            </Popover>
                                            <Button
                                                variant="bordered"
                                                id="eventQrCode"
                                                onPress={() => {
                                                    downloadQRCode(`https://${host}/EventView?code=${data.qrCode}`, `${eventName}-QRCode.png`);
                                                }}
                                                endContent={<QRCode_6_Blue />}
                                            >
                                                Event QRCode
                                            </Button>
                                            <Spacer y={1} />
                                        </div>
                                        <Button
                                            variant="solid"
                                            color='primary'
                                            id="viewEventPage"
                                            onPress={() => {window.open(`/EventView?code=${data.qrCode}`, '_blank')}}
                                            endContent={<ArrowUpRight8White />}
                                        >
                                            Event View Page
                                        </Button>
                                        <Spacer y={3} />
                                        {!isCompleted && (
                                            <Button
                                                isDisabled={!eventDetailsUpdate}
                                                onPress={updateEvent}
                                                color="primary"
                                            >
                                                Update
                                            </Button>
                                        )}
                                    </Form>
                                ))}
                            </Tab>
                        </Tabs>
                    )}
                    <Modal
                        isDismissable={false}
                        isOpen={registrationModalOpen}
                        scrollBehavior="outside"
                        onClose={() => {
                            setRegistrationModalOpen(false);
                            setRegistrationModalInput(false);
                            setRegistrationModalInputValues({})                            
                        }}
                        placement="center"
                        className="w-11/12"
                    >
                        <ModalContent>
                            <ModalHeader className="flex justify-center items-center text-center text-3xl">
                                Registration {registrationModalData.Number}
                            </ModalHeader>
                            <ModalBody>
                                {Object.entries(registrationModalData).filter(
                                    ([key]) => !["number", "registrationid"].includes(key.toLowerCase())).map(([key, value]) => (
                                    <Input
                                        isReadOnly={key.toLowerCase() === "score"}
                                        key={key}
                                        id={key}
                                        type={
                                            ["class", "phone number", "year"].includes(key.toLowerCase()) 
                                            ? "tel" 
                                            : key.toLowerCase() === "email" 
                                            ? "email" 
                                            : "text"
                                        }
                                        label={key.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/^./, (str) => str.toUpperCase())}
                                        variant="bordered"
                                        classNames={{input: "text-[16px]"}}
                                        value={registrationModalInputValues[key]}
                                        onChange={(event) => {
                                            setRegistrationModalInput(true)
                                            setRegistrationModalInputValues((prevValues) => ({
                                                ...prevValues,
                                                [key]: event.target.value
                                            }))
                                        }}
                                        endContent={key.toLowerCase() === "name" && (
                                            <Button
                                                variant="light"
                                                onPress={() => {
                                                    swal.fire({
                                                        title: "Confirm Deletion",
                                                        text: `Delete Registration ${registrationModalData.Number}?`,
                                                        icon: "warning",
                                                        showConfirmButton: true,
                                                        confirmButtonText: "Delete",
                                                        showCancelButton: true,
                                                    }).then((result) => {
                                                        if (result.isConfirmed) {
                                                            deleteRegistration(registrationModalInputValues);
                                                        }
                                                    });
                                                }}
                                            >
                                                <Trash_8_Red />
                                            </Button>
                                        )}
                                    />
                                ))}
                                <Button
                                    variant="solid"
                                    className="w-48 mx-auto"
                                    color="primary"
                                    size="lg"
                                    onPress={() => {
                                        if (registrationModalInput) {
                                            if (registrationModalData.Number) {
                                                updateRegistration(registrationModalInputValues)
                                            }
                                        } else {
                                            swal.fire({
                                                title: "No changes made",
                                                text: "Please make your changes before saving",
                                                icon: "error",
                                                timer: 1500
                                            })
                                        }
                                    }}
                                >
                                    Save
                                </Button>
                            </ModalBody>
                        </ModalContent>
                    </Modal>
                    <Modal
                        isDismissable={false}
                        isOpen={participantModalOpen}
                        scrollBehavior="outside"
                        onClose={() => {
                            setParticipantModalOpen(false);
                            setParticipantModalInput(false);
                            setParticipantModalInputValues((prevValues) => ({
                                ...prevValues,
                                name: '',
                                phoneNumber: '',
                                email: '',
                                admin: ''
                            }))                            
                        }}
                        placement="center"
                        className="w-11/12"
                    >
                        <ModalContent>
                            <ModalHeader className="flex justify-center items-center text-center text-3xl">
                                {participantModalData.participantData && (
                                    Object.values(participantModalData.participantData).every(value => value === '') ? (
                                        <>Add {participantModalData.participantRole}</>
                                    ) : (
                                        <>Edit {participantModalData.participantRole}</>
                                    )
                                )}
                            </ModalHeader>
                            <ModalBody>
                                {participantModalData.participantData &&
                                    Object.entries(participantModalData.participantData).filter(
                                        ([key]) => key !== "registrarId" && key !== "judgeId" && key !== "eventId" && key !== "qrCode"
                                    ).map(([key, value]) => (
                                        key === "admin" ? (
                                            <div className="border-3 border-slate-200 rounded-2xl">
                                                <p className="text-xs pl-3 py-2">
                                                    Administrator
                                                </p>
                                                <Spacer y={1} />
                                                <div className="flex mx-auto w-full justify-center">
                                                    {[1, 0].map((bool) => (
                                                        <Button
                                                            key={key}
                                                            value={value}
                                                            variant={participantModalInputValues[key] === bool ? "solid" : "ghost"}
                                                            color="primary"
                                                            className={`${bool === 1 ? "rounded-r-none w-1/2" : "rounded-l-none w-1/2"}`}
                                                            onPress={() => {
                                                                setParticipantModalInput(true);
                                                                setParticipantModalInputValues((prevValues) => ({
                                                                    ...prevValues,
                                                                    [key]: bool
                                                                }));
                                                            }}
                                                        >
                                                            {bool === 1 ? "Yes" : "No"}
                                                        </Button>
                                                    ))}
                                                </div>                                                
                                            </div>
                                        ) : (
                                            <Input 
                                                key={key}
                                                id={key}
                                                type={
                                                    ["phone number"].includes(key.toLowerCase()) 
                                                    ? "tel" 
                                                    : key.toLowerCase() === "email" 
                                                    ? "email" 
                                                    : "text"
                                                }
                                                isInvalid={key === "email" && !validEmail}
                                                label={key.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/^./, (str) => str.toUpperCase())}
                                                variant="bordered"
                                                classNames={{input: "text-[16px]"}}
                                                value={participantModalInputValues[key]}
                                                onChange={(event) => {
                                                    setParticipantModalInput(true)
                                                    setParticipantModalInputValues((prevValues) => ({
                                                        ...prevValues,
                                                        [key]: event.target.value
                                                    }))
                                                }}
                                                endContent={
                                                    (() => {
                                                        if (key === "name" && value !== '') {
                                                            return (
                                                                <Button
                                                                    variant="light"
                                                                    onPress={() => {
                                                                        swal.fire({
                                                                            title: "Confirm Deletion",
                                                                            text: `Delete ${participantModalData.participantData.name}?`,
                                                                            icon: "warning",
                                                                            showConfirmButton: true,
                                                                            confirmButtonText: "Delete",
                                                                            showCancelButton: true,
                                                                        }).then((result) => {
                                                                            if (result.isConfirmed) {
                                                                                deleteParticipant(
                                                                                    {
                                                                                        participantId: participantModalData.participantData[participantModalData.participantRole === "Registrar" ? "registrarId" : "judgeId"],
                                                                                        participantRole: participantModalData.participantRole,
                                                                                        participantName: participantModalData.participantData.name
                                                                                    }
                                                                                );
                                                                            }
                                                                        });
                                                                    }}
                                                                >
                                                                    <Trash_8_Red />
                                                                </Button>
                                                            );
                                                        } else if (["email", "phoneNumber"].includes(key) && value !== '') {
                                                            return (
                                                                <Button
                                                                    variant="light"
                                                                    isDisabled={
                                                                        (key === "email" && !validEmail) ||
                                                                        (key === "phoneNumber" && !validatePhoneNumber(participantModalInputValues[key]))
                                                                    }
                                                                    onPress={() => {
                                                                        swal.fire({
                                                                            title: "Confirm Invitation",
                                                                            text: `Send invite to ${participantModalInputValues[key]}?`,
                                                                            icon: "warning",
                                                                            showConfirmButton: true,
                                                                            confirmButtonText: "Send",
                                                                            showCancelButton: true,
                                                                        }).then((result) => {
                                                                            if (result.isConfirmed) {
                                                                                sendInvite(
                                                                                    participantModalData.participantRole === "Judge" ? 
                                                                                        participantModalData.participantData.judgeId :
                                                                                        participantModalData.participantData.registrarId,
                                                                                    participantModalData.participantData.name,
                                                                                    participantModalInputValues[key],
                                                                                    participantModalData.participantData.qrCode,
                                                                                    participantModalData.participantRole,
                                                                                    key
                                                                                )
                                                                                
                                                                                setTimeout(() => {
                                                                                    if (value !== participantModalInputValues[key]) {
                                                                                        updateParticipant(participantModalData.participantRole.toLowerCase(), participantModalInputValues);
                                                                                    }
                                                                                }, 1500);
                                                                            }
                                                                        });
                                                                    }}
                                                                >
                                                                    <ShareIcon_6_Blue />
                                                                </Button>
                                                            );
                                                        }
                                                    })()
                                                }
                                            />
                                        )
                                    )
                                )}
                                <Button
                                    variant="solid"
                                    className="w-48 mx-auto"
                                    color="primary"
                                    size="lg"
                                    onPress={() => {
                                        if (participantModalInput) {
                                            const role = participantModalData.participantRole.toLowerCase();

                                            if (participantModalData.participantData.judgeId || participantModalData.participantData.registrarId) {
                                                updateParticipant(role, participantModalInputValues);
                                            } else {
                                                addParticipant(role, participantModalInputValues);
                                            }
                                        } else {
                                            swal.fire({
                                                title: "No changes made",
                                                text: "Please make your changes before saving",
                                                icon: "error",
                                                timer: 1500
                                            })
                                        }
                                    }}
                                >
                                    Save
                                </Button>
                            </ModalBody>
                        </ModalContent>
                    </Modal>
                </div>
            </>
        </LoadScript>
    );
}